import React from 'react';
import { colors, Grid } from '@mui/material';
import { createStyles } from 'app/util/styles';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => createStyles({
  root: {
    paddingBottom: '30px',
    [theme.breakpoints.down('md')]: {
      borderBottom: `1px solid ${colors.grey[300]}`,
      paddingBottom: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
  },
});

export const IndentedWrapper = withStyles(({ ...props }: any) => {
  const { children, classes } = props;
  return (
    <div className={classes.root}>
      <Grid container classes={{ container: 'indent' }}>
        {children}
      </Grid>
    </div>
  );
}, styles);
